export default __webpack_public_path__ + "static/media/1932.4c354eca.png";